import { Viewer3dLoadView3dOptions, Viewer3dRelatedPreviewObject } from '@3ddv/dvm-internal';
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Viewer3dService } from '@3ddv/ngx-dvm-internal';
import { DvmService } from '@services/dvm.service';
import { UiService } from '@services/ui.service';

@Component({
  selector: 'app-preview',
  standalone: true,
  templateUrl: './preview.component.html',
  styleUrl: './preview.component.css'
})
export class PreviewComponent implements OnChanges {

  // INPUTS & OUTPUTS
  @Input({required: true})
  public preview!:           Viewer3dRelatedPreviewObject;

  @Output()
  public openView:           EventEmitter<Viewer3dRelatedPreviewObject> = new EventEmitter<Viewer3dRelatedPreviewObject>();

  @Output()
  public previewError:       EventEmitter<Viewer3dRelatedPreviewObject> = new EventEmitter<Viewer3dRelatedPreviewObject>();

  // VIEWER
  private readonly viewer3d: Viewer3dService                  = inject(DvmService).viewer3d;
  private readonly uiconfig                                   = inject(UiService).uiConfig;
  private readonly cdr:      ChangeDetectorRef                = inject(ChangeDetectorRef);

  // COMPONENT STATE
  private options:           Viewer3dLoadView3dOptions | null = null;
  public thumbnail:          string | null                    = null;
  public loading:            boolean                          = false;
  public hasError:           boolean                          = false;

  // LIFECYCLE HOOKS
  ngOnChanges(changes: SimpleChanges): void {

    if(changes['preview'] && changes['preview'].currentValue) {
      this.loadComponent();
    }
    
  }
 
  // METHODS
  public loadPreview(): void {
    
    if(this.loading || this.hasError) return; // Si ya esta cargando o hay error no hacemos nada

    this.loading = true;
    this.viewer3d.loadView3d(this.options!).subscribe((): boolean => this.loading = false);

    this.openView.emit(this.preview);

  }

  private loadComponent(): void {

    const viewVersion: string = this.uiconfig().View3dDisplay.viewVersion;
    this.options = {view_id: this.preview.view_id, venue_id: this.preview.venue_id, ...(viewVersion ? { set_id: viewVersion } : {})};
    this.loading = true;
    this.hasError = false;

    this.viewer3d.getThumbnail(this.options, true).subscribe({
      next: (url: string): void => {
        
        this.thumbnail = url ?? null;
        this.loading = false;
        
        // Detectamos cambios ( usamos el cdr porque zone run es muy pesado )
        this.cdr.detectChanges();

      },
      error: (err: Error): void => {
        
        this.hasError = true;
        this.loading = false;
        
        // Emitimos el error al componente padre
        this.previewError.emit(this.preview);
        
        // Detectamos cambios
        this.cdr.detectChanges();

        throw new Error(err.message);
        
      }
    });

  }
  
}
